import { CreateItemGqlError, CreateItemGqlStatus } from '../../../../types';
import { CreateCustomFieldCacheKeys } from '../../customFieldsTypes';

import { CACHE_CREATE_CUSTOM_FIELD_QUERY } from '../../queries/cacheCreateCustomField.query';

import { useCacheCreateQuery } from '../../../common/reactQuery/hooks/useCacheCreateQuery';

interface CacheCreateCustomFieldOptions {
  cacheKeys?: CreateCustomFieldCacheKeys;
}

export interface CacheCreateCustomFieldInput {
  companyId: string;
  checkedAt?: string;
  label?: string;
  body?: string;
  location: string;
  order?: number;
  options?: Record<string, unknown>;
}

export interface CacheCreateCustomFieldCustomFieldValueRecord {
  companyId: number;
  createdAt: string;
  customFieldId: number;
  defaultAt: string | null;
  id: string;
  text: string;
  updatedAt: string;
  uuid: string;
}

export interface CacheCreateCustomFieldRecord {
  body?: string;
  checkedAt?: string;
  companyId: number;
  createdAt: string;
  customFieldValues?: CacheCreateCustomFieldCustomFieldValueRecord[];
  id: string;
  label: string;
  location: string;
  options?: Record<string, unknown>;
  updatedAt: string;
  userId: number;
  uuid: string;
}

export interface CacheCreateCustomFieldResponse {
  createCustomField: {
    status: CreateItemGqlStatus;
    record: CacheCreateCustomFieldRecord;
    errors: CreateItemGqlError;
    recordId: string;
    recordNanoId?: string;
    recordUuid?: string;
  };
}

export interface CacheCreateCustomFieldError {
  fullMessages: string[];
}

const action = 'createCustomField';

function useCacheCreateCustomField({
  cacheKeys
}: CacheCreateCustomFieldOptions = {}) {
  const {
    createCacheQuery,
    createCacheQueryData,
    createCacheQueryError,
    createCacheQueryErrorMessage,
    createCacheQueryLoading,
    createCacheQueryReset
  } = useCacheCreateQuery<
    CacheCreateCustomFieldInput,
    CacheCreateCustomFieldResponse,
    CacheCreateCustomFieldError,
    CacheCreateCustomFieldRecord
  >({
    action,
    query: CACHE_CREATE_CUSTOM_FIELD_QUERY,
    cacheKeys
  });

  return {
    createCustomField: createCacheQuery,
    createCustomFieldData: createCacheQueryData,
    createCustomFieldError: createCacheQueryError,
    createCustomFieldErrorMessage: createCacheQueryErrorMessage,
    createCustomFieldLoading: createCacheQueryLoading,
    createCustomFieldReset: createCacheQueryReset
  };
}

export default useCacheCreateCustomField;
